import React from 'react'
import withSend from 'microcosm/addons/with-send'
import Header from 'lib/components/header/mobile-header'
import Select from 'lib/components/select'

import LOGO_URL from 'lib/images/logo.svg'

const options = [
  { text: 'Strategies', value: 'strategies' },
  { text: 'Factors', value: 'factors' }
]

class MobileHeader extends React.PureComponent {
  onSelectChange = event => {
    event.target.blur()
    this.props.send('visit', event.target.value)
  }

  auxContent = () => {
    const option =
      options.find(opt => opt.value === this.props.section) || options[0]

    return (
      <div className="mobile-header__select">
        <Select
          label="Select Equity Category"
          labelFor="location-filter"
          labelVisible={false}
          onChange={this.onSelectChange}
          options={options}
          selected={option.value}
          selectedText={option.text}
        />
      </div>
    )
  }

  render() {
    return <Header logoUrl={LOGO_URL} navAuxContent={this.auxContent} />
  }
}

export default withSend(MobileHeader)



// WEBPACK FOOTER //
// ./src/components/mobile/header.js